import { ContentBlock, EditorState, Modifier } from 'draft-js';
import { FollowupData } from '../types';
import followupTextSelection from '../utils/followupTextSelection';

export default function addFollowup(
  editorState: EditorState,
  block: ContentBlock,
  followup: FollowupData,
): EditorState {
  const contentStateWithEntity = editorState
    .getCurrentContent()
    .createEntity('followup', 'IMMUTABLE', followup);
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  const currentSelectionState = editorState.getSelection();
  const followupSelection = followupTextSelection(editorState, followup, block.getKey());
  const followupReplacedContent = Modifier.applyEntity(
    contentStateWithEntity,
    followupSelection,
    entityKey,
  );
  const newEditorState = EditorState.push(editorState, followupReplacedContent, 'insert-fragment');

  // make sure user's cursor stays where it was when we started
  return EditorState.forceSelection(newEditorState, currentSelectionState);
}
